$(document).ready(function () {
  $("body").on("change", ".custom-file-input", function() {
    if ($(this)[0].files[0] !== undefined) {
      var targetLabel = $(this).parent().find("label");

      targetLabel.find("span").html($(this)[0].files[0].name);
      targetLabel.removeClass("btn-outline-secondary");
      targetLabel.addClass("btn-secondary");
      targetLabel.find(".re-upload-icon").removeClass("d-none");
    }
  });
});
